import PropTypes from 'prop-types'
import React from 'react'
import FileCitizenField from '../question_fields/FileCitizenField'

const Citizen = props => {
  const { index, name, question, margin } = props
  return <FileCitizenField index={index} {...question} name={name} margin={margin} />
}

const FileQuestion = {
  Citizen,
  name: 'FileQuestion'
}

export default FileQuestion

Citizen.propTypes = {
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
